
import link from './email-editor.link';

export default function emailEditor () {
	return {
		restrict:'E',
		scope: {
			html: '='
		},
		template: '<div></div>',
		replace: true,
		link
	};
};

emailEditor.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/email-editor/email-editor.js